<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1050px"
      title="加工单列表"
      id-key="UserId"
      @close-saved="$emit('close-saved')" 
    >
       <list ref="list"  :temp-params="{Statuses :[3,4],ProductionType: 0, Stage: Stage, OrderType}" disabled  :tableType="1"></list>  
        <div slot="footer">
          <el-button type="primary" @click="saved">保存</el-button>
       </div>      
    </common-dialog>
  </div>
</template>  
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import list from "@/views/business/stock/workList/index";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    list,
  },
  props: {
    DictionaryId:{
      type: Number,
      default: 0,
    },
    Stage: {
      type: Number,
      default: 0,
    },
    OrderType: {
      type: Number,
      default: 0,
    }

  },
  data(){
    return{
      tableDataCop:null
    }
  },
  methods: {
    get_data(o){
      this.$nextTick(() => {
        this.tableDataCop = this.$parent.tableData.filter(item => item.ProductNo !== '' || item.ProductName !== '')
        console.log('o', o)
        this.$refs.list.$refs.list.query(o)
      })
    },
    saved(){
      console.log('原有的数据:',this.tableDataCop);
      console.log('被勾选的数据:',this.$refs.list.subList);
      
      if(this.tableDataCop.some(obj1 => this.$refs.list.subList.some(obj2 => obj1.ProductName === obj2.ProductName && obj1.ProductNo === obj2.ProductNo))){
        this.$message.warning('不可重复添加')
        return
      }

      let list = this.$refs.list.list;
      let subList = this.$refs.list.subList;
      let extraList = this.$refs.list.extraList;
      console.log("list",list,"sublist",subList,"extralist",extraList);
      this.$emit('saved', {
        list,
        subList,
        extraList
      });
      this.close();
    }
  }  
};
</script>
